import { NgModule } from "@angular/core";
import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { AuthGuardService } from "./auth-gaurd.service";
import { DocTokenResolver } from "./docTokenResolver";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./home/home.module").then((m) => m.HomePageModule),
    canActivate: [AuthGuardService],
    resolve: [DocTokenResolver],
  },

  // {
  //   path: "careteam",
  //   loadChildren: () =>
  //     import("./careteam/careteam.module").then((m) => m.CareteamPageModule),
  //   canActivate: [AuthGuardService],
  // },

  {
    path: "session-expired",
    loadChildren: () =>
      import("./session-expired/session-expired.module").then(
        (m) => m.SessionExpiredPageModule
      ),
  },

  {
    path: "login",
    loadChildren: () =>
      import("./login/login.module").then((m) => m.LoginPageModule),
  },
  {
    path: "session",
    loadChildren: () =>
      import("./session-check/session-check.module").then(
        (m) => m.SessionCheckPageModule
      ),
  },
];
const extraOptions: ExtraOptions = {
  enableTracing: false,
};
@NgModule({
  imports: [RouterModule.forRoot(routes, extraOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
